import React, { useEffect, useState } from 'react'

export default function VideoDialog() {
  const [url, setUrl] = useState(``)
  useEffect(() => {
    const url =
      process.env.REACT_APP_API_BASE_URL?.replace(`api/v1/`, ``) || `http://localhost:8000/`
    setUrl(url)
  }, [])
  return (
    <video style={{ width: `100%` }} controls autoPlay={true}>
      <source src={`${url}files/capacitacion.mp4`} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  )
}
